import { render, staticRenderFns } from "./chooseGroup.vue?vue&type=template&id=c4990cf0&"
import script from "./chooseGroup.vue?vue&type=script&lang=js&"
export * from "./chooseGroup.vue?vue&type=script&lang=js&"
import style0 from "./chooseGroup.vue?vue&type=style&index=0&id=c4990cf0&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports